module.exports = __webpack_public_path__ + "static/assets/recycle-status.67b4a5f4.png";